module.exports = __webpack_public_path__ + "assets/img/tx202s_1.73a3e4d5.jpg";